import { createNewProject, clarifyMessage } from './api';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './ChatPage.css';

const ChatInput = ({ user, project, messages, setMessages, setProjects, setSelectedProject, loading, setLoading, creative }) => {
  const [text, setText] = useState('');
  const textAreaRef = useRef(null);
  const navigate = useNavigate(); 
  
  let currentProject = project;

  const handleSend = async () => {
    if (!text || !project || loading) return;

    const userMessage = { sender: 'user', text };
    setMessages((prev) => [...prev, userMessage]);
    setText('');
    setLoading(true);

    try {
      let assistantResponse;

      if (!project.idx) {
        const res = await createNewProject(user.uid, text, project.duration, 'TUBITAK');
        const newProj = { idx: res.idx, title: res.title };
        setSelectedProject(newProj);
        setProjects((prev) => [...prev, newProj]);
        assistantResponse = res.text;
        currentProject = newProj;
      } else {
        assistantResponse = await clarifyMessage(project.idx, text);
      }

      if (assistantResponse === 'COMPLETED') {
        navigate('/project_preparation', { state: { idea_idx: currentProject.idx, title: currentProject.title, min_duration: 10000, creative: creative} });
      } else {
        setMessages((prev) => [...prev, { sender: 'bot', text: assistantResponse }]);
      }

    } catch (err) {
      // Rollback user's message
      setMessages(prev => prev.slice(0, -1));

      let errorMsg = 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.';

      if (err.response) {
        if (err.response.status === 500) {
          errorMsg = 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.';
        } else if (err.response.data?.message) {
          errorMsg = err.response.data.message;
        }
      } else if (err.message) {
        errorMsg = err.message;
      }

      console.error('Message send error:', err);

      // Show error message from bot instead of an alert
      setMessages(prev => [...prev, { sender: 'bot', text: errorMsg }]);

    } finally {
      setLoading(false);
    }
  };


  const handleChange = (e) => {
    setText(e.target.value);
  };

  useEffect(() => {
    const textarea = textAreaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Adjust based on content
    }
  }, [text]);

  return (
    <div className="chat-input">
      <textarea
        ref={textAreaRef}
        rows="1"
        value={text}
        placeholder="Proje fikrinizi anlatınız..."
        onChange={handleChange}
        disabled={loading}
      />
      <button onClick={handleSend} disabled={loading}>↑</button>
    </div>
  );
};

export default ChatInput;
